module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"user.latest_access.tooltip":"เวลาที่เข้าใช้งานในระบบล่าสุด","user.latest_access.empty":"ยังไม่เคยเข้าใช้งานระบบ","user.latest_access.prefix":"เข้าใช้งานล่าสุด เมื่อ "}}')
  delete Component.options._Ctor
}
